export const INSTITUTION = 'Выберите учреждение';
